import React, { useEffect, useState } from "react"
import Author1 from "../../../static/images/author-1.jpg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInstagram } from "@fortawesome/free-brands-svg-icons"
import { faFacebook } from "@fortawesome/free-brands-svg-icons"
import { faTwitter } from "@fortawesome/free-brands-svg-icons"
import { Parallax } from "react-scroll-parallax"
import { Link } from "gatsby"

function aboutHeader() {
  return (
    <div>
      <div className="row d-flex my-5" data-scrollax-parent="true">
        <Parallax className="col-md-4" y={[30, -30]} tagOuter="figure">
          <div
            className=" author-img"
            style={{ backgroundImage: "url(" + Author1 + ")" }}
            data-scrollax=" properties: { translateY: '-70%'}"
          ></div>
        </Parallax>
        <div className="col-md-2"></div>
        <div className="col-md-6 wrap ftco-animate" data-aos="fade-up">
          <div className="about-desc">
            <h1 className="bold-text">About</h1>
            <div className="p-5">
              <h2 className="mb-5">Hi! I'm Junaid Elahi</h2>
              <p>
                Far far away, behind the word mountains, far from the countries
                Vokalia and Consonantia, there live the blind texts. Separated
                they live in.
              </p>
              <p>
                <Link to="about">Checkout my resume</Link>
              </p>
              <ul className="ftco-footer-social list-unstyled mt-4">
                <li>
                  <a href="#">
                    <FontAwesomeIcon
                      className="fontAwesomeIcon"
                      icon={faTwitter}
                    />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <FontAwesomeIcon
                      className="fontAwesomeIcon"
                      icon={faFacebook}
                    />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <FontAwesomeIcon
                      className="fontAwesomeIcon"
                      icon={faInstagram}
                    />
                  </a>
                </li>
              </ul>
              <h5>Contact me here!</h5>
              <p>
                Email: <a href="#">johnyrj97@gmail.com</a>
              </p>
              <p>
                Phone: <a href="#">+92-323-7144496</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default aboutHeader
